import { render, staticRenderFns } from "./MerchantCategoryProducts.vue?vue&type=template&id=e0754008&scoped=true&"
import script from "./MerchantCategoryProducts.vue?vue&type=script&lang=js&"
export * from "./MerchantCategoryProducts.vue?vue&type=script&lang=js&"
import style0 from "./MerchantCategoryProducts.vue?vue&type=style&index=0&id=e0754008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0754008",
  null
  
)

export default component.exports